var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.92 11.6C19.9 6.91 16.1 4 12 4s-7.9 2.91-9.92 7.6c-.111.255-.111.545 0 .8C4.1 17.09 7.9 20 12 20s7.9-2.91 9.92-7.6c.111-.255.111-.545 0-.8zM12 18c-3.17 0-6.17-2.29-7.9-6C5.83 8.29 8.83 6 12 6s6.17 2.29 7.9 6c-1.73 3.71-4.73 6-7.9 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-1.06-.421-2.078-1.172-2.828C14.078 8.422 13.061 8 12 8zm0 6c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eyeOpen.7322741efcd76af585f1b200716b7d89.svg";